import { render, staticRenderFns } from "./AnalyticsTransactions.vue?vue&type=template&id=ddee1380"
import script from "./AnalyticsTransactions.vue?vue&type=script&lang=js"
export * from "./AnalyticsTransactions.vue?vue&type=script&lang=js"
import style0 from "./AnalyticsTransactions.vue?vue&type=style&index=0&id=ddee1380&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports